import type { OpsGeoAsset } from "../types";

export interface GeoAssetCoordinates {
  lat: number;
  lng: number;
}

/** Read the single ADR-003 placement authority exposed by the API. */
export function readGeoAssetCoordinates(
  asset: OpsGeoAsset,
): GeoAssetCoordinates | null {
  const position = asset.current_position;
  if (!position) return null;
  const { latitude: lat, longitude: lng } = position;
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return { lat, lng };
}

/** Move an already positioned DU optimistically without reviving metadata. */
export function withOptimisticGeoAssetCoordinates(
  asset: OpsGeoAsset,
  duId: string,
  coordinates: GeoAssetCoordinates,
): OpsGeoAsset {
  const metadata = asset.metadata as Record<string, unknown>;
  if (metadata.du_id !== duId || !asset.current_position) return asset;
  return {
    ...asset,
    current_position: {
      ...asset.current_position,
      latitude: coordinates.lat,
      longitude: coordinates.lng,
    },
  };
}
